import { urlZendeskService } from '@src/endpoints'
import axios from "axios"

export const GetAllTickets = async () => {
  try {
    const response = await axios.get(`${urlZendeskService}/GetAllZenDeskTickets`)
    if (response.data.success) {
      return { success: true, data: response.data.data }
    } else {
      // Only return message if there's an actual error, not just empty data
      return { success: false, message: response.data.errors?.[0] || null }
    }
  } catch (error) {
    // Only show error for actual network/server errors
    console.error('Error getting tickets:', error)
    return { success: false, message: error.response ? 'Failed to fetch tickets from server' : 'Network error' }
  }
}

export const PublishTicket = async (ticketData) => {
  try {
    const payload = {
      ticket: {
        subject: ticketData.subject,
        comment: {
          body: ticketData.description
        },
        requester: {
          name: ticketData.requesterName,
          email: ticketData.requesterEmail
        }
      }
    }

    const response = await axios.post(`${urlZendeskService}/PublishTicket`, payload)
    if (response.data.success) {
      return { success: true, data: response.data.data }
    } else {
      return { success: false, message: response.data.errors[0] }
    }
  } catch (error) {
    return { success: false, message: 'Error creating ticket' }
  }
}